import { QuoteRecallErrorFields } from "@/utils/error-handling";
import { defineStore } from "pinia";
import { RouteLocationNormalized, Router } from "vue-router";
import { APP_STEP } from "./types";

declare module "pinia" {
    export interface PiniaCustomProperties {
        router: Router;
    }
}

export interface MainState {
    appStep: APP_STEP;
    isLoading: boolean;
    loadingPopupText: string;
    guardStep: APP_STEP;
    isMonthly: boolean;
    sessionExpiry: {
        showTimeoutModal: boolean;
    };
    displayStartDateIsInvalidModal: boolean;
    displayQuoteExpiredModal: boolean;
    displayQuoteAcceptedModal: boolean;
    displayNotQuotedModal: boolean;
    quoteRecallErrors: {
        reference: boolean;
        name: boolean;
        dob: boolean;
        accepted: boolean;
        expired: boolean;
        notQuoted: boolean;
    };
    stopNavigation: boolean;
    displayBrowserNavigationModal: boolean;
    resetQuote: boolean;
    fromPaymentFailed: boolean;
    previousRoute: RouteLocationNormalized | null;
    displayAdditionalAssistanceModal: boolean;
}

const state: MainState = {
    appStep: APP_STEP.ABOUT_YOU,
    isLoading: false,
    loadingPopupText: "Loading data...",
    guardStep: APP_STEP.ABOUT_YOU,
    sessionExpiry: {
        showTimeoutModal: false
    },
    isMonthly: false,
    displayStartDateIsInvalidModal: false,
    displayQuoteExpiredModal: false,
    displayQuoteAcceptedModal: false,
    displayNotQuotedModal: false,
    quoteRecallErrors: {
        reference: false,
        name: false,
        dob: false,
        accepted: false,
        expired: false,
        notQuoted: false
    },
    stopNavigation: false,
    displayBrowserNavigationModal: false,
    resetQuote: false,
    fromPaymentFailed: false,
    previousRoute: null,
    displayAdditionalAssistanceModal: false,
};

export const useMainStore = defineStore("main", {
    state: () => state,
    actions: {
        setAppStep(step: APP_STEP) {
            this.appStep = step;
        },
        setLoadingState(state) {
            console.log("setLoadingState");
            this.isLoading = state;
        },
        setLoadingStatePopupText(state) {
            this.loadingPopupText = state;
        },
        setGuardStep(step: APP_STEP) {
            this.guardStep = step;
        },
        setIsMonthly(state) {
            this.isMonthly = state;
        },
        setDisplayStartDateIsInvalidModal(state) {
            this.displayStartDateIsInvalidModal = state;
        },
        setResetQuote(state) {
            this.resetQuote = state;
        },
        setDisplayQuoteExpiredModal(state: boolean) {
            this.displayQuoteExpiredModal = state;
        },
        setDisplayQuoteAcceptedModal(state: boolean) {
            this.displayQuoteAcceptedModal = state;
        },
        setDisplayNotQuotedModal(state: boolean) {
            this.displayNotQuotedModal = state;
        },
        setQuoteRecallErrors(fieldName: QuoteRecallErrorFields) {
            const fields = {
                reference: [QuoteRecallErrorFields.REFERENCE],
                name: [QuoteRecallErrorFields.NAME],
                dob: [QuoteRecallErrorFields.DOB],
                accepted: [QuoteRecallErrorFields.ACCEPTED],
                expired: [QuoteRecallErrorFields.EXPIRED],
                expired_offline: [QuoteRecallErrorFields.EXPIRED_OFFLINE],
                not_quoted: [QuoteRecallErrorFields.NOT_QUOTED],
                reset: [
                    QuoteRecallErrorFields.NAME,
                    QuoteRecallErrorFields.REFERENCE,
                    QuoteRecallErrorFields.DOB,
                    QuoteRecallErrorFields.ACCEPTED,
                    QuoteRecallErrorFields.EXPIRED,
                    QuoteRecallErrorFields.EXPIRED_OFFLINE,
                    QuoteRecallErrorFields.NOT_QUOTED
                ]
            };

            const shouldSetError = fieldName !== QuoteRecallErrorFields.RESET;

            (fields[fieldName] || []).forEach(field => {
                this.quoteRecallErrors[field] = shouldSetError;
            });
        },
        setFromPaymentFailed(value: boolean) {
            this.fromPaymentFailed = value;
        }
    }
});
